import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=790f7ee5&scoped=true&"
import script from "./CountryFlag.vue?vue&type=script&lang=ts&"
export * from "./CountryFlag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f7ee5",
  null
  
)

export default component.exports